import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Typography from '../../typography/Typography';
import { ColorTokens, TypographyTypeDLS } from '@voltmoney/schema';
const HorizontalFilterComp = ({ title, noOfItems, selected, onPress, activeIndex, }) => {
    return (React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
            onPress({ activeIndex });
        } },
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingLeft: 5,
                paddingRight: 16,
                paddingTop: 5,
                paddingBottom: 5,
                backgroundColor: selected ? '#E7EBFA' : '#F1F3F5',
                borderRadius: 16
            } },
            React.createElement(View, { style: {
                    borderRadius: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 8,
                    paddingRight: 8,
                    marginRight: 8,
                    backgroundColor: selected ? '#D0D6F5' : '#E4E7EC',
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: noOfItems, color: selected ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
            React.createElement(View, null,
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0M, label: title, color: selected ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })))));
};
const styles = StyleSheet.create({});
export default HorizontalFilterComp;
